import { initializeApp } from "firebase/app"
import { getMessaging, getToken, isSupported } from "firebase/messaging"

export default defineNuxtPlugin(nuxtApp => {
  const config = useRuntimeConfig()

  const firebaseConfig = {
    apiKey: config.public.firebaseApiKey,
    authDomain: config.public.firebaseAuthDomain,
    projectId: config.public.firebaseProjectId,
    storageBucket: config.public.firebaseStorageBucket,
    messagingSenderId: config.public.firebaseMessagingSenderId,
    appId: config.public.firebaseAppId,
    measurementId: config.public.firebaseMeasurementId,
  }

  // Chỉ khởi tạo 1 lần duy nhất
  const app = initializeApp(firebaseConfig)
  let messaging = null

  const registerFcmToken = async () => {
    if (!(await isSupported())) {
      console.warn("Firebase Messaging is not supported in this browser")
      return
    }

    if (!messaging) {
      messaging = getMessaging(app)
    }

    try {
      const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js", { type: "module" })

      const { data: auth } = useAuth()
      const accessToken = auth?.value?.token

      const token = await getToken(messaging, {
        vapidKey: config.public.firebaseVapidKey,
        serviceWorkerRegistration: registration,
      })

      if (token) {
        await $fetch(`${config.public.apiBaseUrl}/notifications/fcm/register`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          body: { fcmId: token, userId: auth?.value?.user?.id, device: 3 },
        })
      }
    } catch (err) {
      console.error("Error getting FCM token:", err)
    }
  }

  return {
    provide: {
      registerFcmToken,
    },
  }
})